import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  chip: {
    backgroundColor: colors.neutral.cotton,
    borderColor: colors.disabled.smoke,
    borderRadius: scale(12),
    borderWidth: 1,
    marginRight: scale(10),
    paddingHorizontal: scale(12),
    paddingVertical: scale(6),
  },
  chipLabel: {
    color: colors.neutral.charcoal,
  },
  chipLabelActive: {
    color: colors.neutral.charcoal,
  },
  chipRow: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
  },
  chipSelected: {
    backgroundColor: colors.secondary.softOrchid,
    borderColor: colors.secondary.orchid,
  },
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  settingsButton: {
    padding: scale(4),
  },
});

export default styles;
